import React from 'react';
import {
  FormattedMessage,
  defineMessages,
} from 'react-intl';
import st from 'core/shared-translations';

export const LogoHeader = () => (
  <div>
    <nav id="navbar" className="navbar navbar-lite" role="navigation">
      <div className="container-fluid">
        <div className="navbar-header">
          <a className="navbar-brand-lite" href="#"><FormattedMessage {...st['shared.navbar.my-account']} /></a>
        </div>
      </div>
    </nav>
    <div className="container-fluid navbar-gray-background" />
  </div>
);

export default LogoHeader;
